import { htmlToText } from "@pathwright/utils/src/text/htmlToText"

const MEDIA_SELECTOR = "img, video, audio, iframe, embed, object, hr"

/** Empty lines and whitespace are empty; text, media, and dividers are content. */
export function isEmpty(html: string | null | undefined): boolean {
  if (!html?.trim()) return true
  if (typeof DOMParser !== "undefined") {
    const document = new DOMParser().parseFromString(html, "text/html")
    document.body
      .querySelectorAll("script, style, template")
      .forEach((node) => node.remove())
    if (document.body.querySelector(MEDIA_SELECTOR)) return false
    return !(document.body.textContent || "")
      .replace(/[\u200b\u200c\u200d\ufeff]/g, "")
      .trim()
  }

  // Match browser semantics when rendering without a DOM. Entities generated
  // for blank editor lines must not turn into visible text in this fallback.
  const content = html
    .replace(/<!--[\s\S]*?-->/g, "")
    .replace(/<(script|style|template)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, "")
  if (/<(?:img|video|audio|iframe|embed|object|hr)\b/i.test(content))
    return false
  return !htmlToText(content)
    .replace(/&(?:nbsp|#0*160|#x0*a0|#0*8203|#x0*200b);/gi, " ")
    .replace(/[\u200b\u200c\u200d\ufeff]/g, "")
    .trim()
}
